import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export enum Pages {
  ROOT = '/',
  HOME = '/national',
}

/** Rewrites '/' to '/national' */
export const normalisedUrl = (href: string) => {
  if (href === `${Pages.ROOT}`) {
    return Pages.HOME;
  }
  /** To avoid parsing maps coords */
  return href.split('@')[0].replace(/\/$/, '') || '/';
};

export const useNormalisedPathname = () => {
  const rawPathname = normalisedUrl(useLocation().pathname);
  const [pathname, setNormalisedPathname] = useState(rawPathname);

  useEffect(() => {
    setNormalisedPathname(rawPathname);
  }, [rawPathname]);

  return pathname;
};
